<template>
  <cobrand :affiliates="true">
    <div class="bg-white h-100 mh-100vh d-flex flex-column">
      <LayoutBase></LayoutBase>
      <AppHeader></AppHeader>
      <div id="app">
        <slot />
      </div>
      <div class="secondary-logo"></div>
      <AppFooter></AppFooter>
    </div>
  </cobrand>
</template>

<script>
import AppFooter from '~/components/AppFooter'
import AppHeader from '~/components/AppHeader'
import Cobrand from '~/components/Cobrand'
import LayoutBase from './base'

export default {
  components: {
    AppFooter,
    AppHeader,
    Cobrand,
    LayoutBase
  }
}
</script>

<style lang="scss" scoped>


.mh-100vh {
  min-height: 100vh;
}

#app {
  flex: 1 0 auto;
  padding-bottom: 80px;
}

// We have to override some styles with important to get higher precedence than the scoped styles in the footer
#base-footer {
  .base-footer-bottom {
    margin: 0 auto;
    max-width: 1200px;
    background-color: $background-100 !important;
  }

  .text-container {
    padding: 10px 0 !important;
  }
}
</style>

<style lang="scss">
/* Sticky Footer */
html, body, #__nuxt, #main-flex {
  /* Any container housing the flexboxes needs to be AT LEAST 100% height! */
  min-height: 100vh;
}
</style>
